module.exports = __webpack_public_path__ + "img/部门管理.fd9f50c7.png";